import { defaultFeatureIcons } from '../components/AcquireFlowFeatureComparison1'

export interface Feature {
  icon: React.ReactNode
  label: string
  hasFeature: boolean
  competitorHasFeatures: boolean[]
}

export const comparisonFeatures: Feature[] = [
  {
    icon: defaultFeatureIcons.zap,
    label: 'Outreach Speed',
    hasFeature: true,
    competitorHasFeatures: [false, false, false],
  },
  {
    icon: defaultFeatureIcons.dollarSign,
    label: 'Cost per Offer',
    hasFeature: true,
    competitorHasFeatures: [false, false, false],
  },
  {
    icon: defaultFeatureIcons.target,
    label: 'Market Reach',
    hasFeature: true,
    competitorHasFeatures: [false, false, false],
  },
  {
    icon: defaultFeatureIcons.checkCircle,
    label: 'Lead Quality Accuracy',
    hasFeature: true,
    competitorHasFeatures: [false, false, false],
  },
  {
    icon: defaultFeatureIcons.settings,
    label: 'Setup & Maintenance',
    hasFeature: true,
    competitorHasFeatures: [false, false, false],
  },
  {
    icon: defaultFeatureIcons.zap,
    label: 'Automation Level',
    hasFeature: true,
    competitorHasFeatures: [false, false, false],
  },
]
